package com.milta.core.localization.translations.de

import com.milta.core.localization.AdminPromptsStrings

internal val AdminPrompts = AdminPromptsStrings(
    loading = "Wird geladen…",
    errorNoConnection = "Server nicht erreichbar — bitte Verbindung prüfen.",
    errorGeneric = "Ein Fehler ist aufgetreten. Bitte später erneut versuchen.",
    contractLockedNotice = "🔒 Der Ausgabevertrag (JSON-Format) bleibt gesperrt — er wird serverseitig automatisch nach dem bearbeiteten Text hinzugefügt, damit die Extraktion in der Produktion nie beschädigt wird.",
    notModifiedLabel = "Standardwert — nie geändert",
    modifiedOnPrefix = "Geändert am",
    resetToDefaultAction = "↺ Auf Standardwerte zurücksetzen",
    editableBodyLabel = "✏️ Bearbeitbarer Inhalt — Geschäftsregeln",
    markdownBoldSnippet = "**fetter Text**",
    markdownItalicSnippet = "*kursiver Text*",
    markdownCodeSnippet = "`Code`",
    markdownHeadingSnippet = "## Überschrift",
    markdownBulletSnippet = "- Listenelement",
    markdownNumberedSnippet = "1. Listenelement",
    markdownQuoteSnippet = "> Zitat",
    previewToggleEdit = "✏️ Bearbeiten",
    previewToggleShow = "👁 Vorschau",
    contractFooterLabel = "🔒 Ausgabevertrag — gesperrt, automatisch hinzugefügt",
    actionErrorOffline = "Fehlgeschlagen — bitte Verbindung prüfen.",
    actionErrorGeneric = "Speichern fehlgeschlagen, bitte erneut versuchen.",
    unsavedChangesNotice = "● Ungespeicherte Änderungen",
    savingAction = "Wird gespeichert…",
    saveAction = "Änderungen speichern",
)
